var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "FormFieldsContainer",
        { attrs: { titulo: "Acciones" } },
        [
          _c(
            "v-radio-group",
            {
              staticClass: "layout row wrap justify-center",
              attrs: { row: "" }
            },
            [
              _c(
                "v-flex",
                { attrs: { sm3: "", md3: "" } },
                [
                  _c("v-radio", {
                    attrs: { value: "RetiroEquipo", label: "Retiro de equipo" },
                    on: {
                      change: function($event) {
                        return _vm.cambio_tipo($event, "RetiroEquipo")
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm3: "", md3: "" } },
                [
                  _c("v-radio", {
                    attrs: {
                      value: "reemplazaEquipo",
                      label: "Reemplazo Equipo"
                    },
                    on: {
                      change: function($event) {
                        return _vm.cambio_tipo($event, "reemplazaEquipo")
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm3: "", md3: "" } },
                [
                  _c("v-radio", {
                    attrs: { value: "CambioSIM", label: "Reemplazo SIM" },
                    on: {
                      change: function($event) {
                        return _vm.cambio_tipo($event, "CambioSIM")
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm3: "", md3: "" } },
                [
                  _c("v-radio", {
                    attrs: {
                      value: "CambioActivoCliente",
                      label: "Cambio de Activo de Cliente"
                    },
                    on: {
                      change: function($event) {
                        return _vm.cambio_tipo($event, "CambioActivoCliente")
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }